import React, { useEffect, useState, FC } from "react";
import { Button, Modal , Grid} from 'semantic-ui-react';

interface IProps {
    open: boolean,
    onConfirm: any,
    onClose: any
}

const IFrameSettingsModal: FC<IProps> = ({ open, onConfirm, onClose }) => {

    const [height, setHeight] = useState<string>();
    const [width, setWidth] = useState<string>();


    const handleBlur = (e: any) => {
        if (e.currentTarget.value === '0') e.currentTarget.value = '1'
    }

    const handleKeypress = (e: any) => {
        const characterCode = e.key
        if (characterCode === 'Backspace') return

        const characterNumber = Number(characterCode)
        if (characterNumber >= 0 && characterNumber <= 9) {
            if (e.currentTarget.value && e.currentTarget.value.length) {
                return
            } else if (characterNumber === 0) {
                e.preventDefault()
            }
        } else {
            e.preventDefault()
        }
    }


    const confirmChangeHandler = () =>
    {
        let iframeSettings = {
            height: height,
            width: width
        };

        onConfirm(iframeSettings);
    }
    useEffect(() => {
    }, []);
    return (
        <Modal
            id= "iFrameModal"
            open={open}
            onClose={onClose} >
            <Modal.Header>Configure iFrame Settings</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div className="meta" style={{ marginBottom: 10 }}>Adaptive sizing is applied if height and width are left blank</div>
                        <Grid>
                            <Grid.Column width={8}>
                                <div className="header gray headerStyleGray">HEIGHT (PX)</div>  
                                <div className="ui input fluid" style={{ width: '80%', marginLeft: '10px' }} >
                                    <input id="height" type="number" style={{ backgroundColor: "#e5e5e5" }} value={height} onKeyDown={handleKeypress} onBlur={handleBlur} onChange={(e) => { setHeight(e.target.value) }} placeholder="Enter Height" />
                                </div>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <div className="header gray headerStyleGray">WIDTH (PX)</div>
                                <div className="ui input fluid" style={{ width: '80%', marginLeft: '10px' }} >
                                    <input id="width" type="number" style={{ backgroundColor: "#e5e5e5" }} value={width} onKeyDown={handleKeypress} onBlur={handleBlur} onChange={(e) => { setWidth(e.target.value) }} placeholder="Enter Width" />
                                </div>
                            </Grid.Column>
                        </Grid>
                   
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={confirmChangeHandler}>Confirm</Button>
                <Button onClick={onClose}>Cancel</Button>
            </Modal.Actions>
        </Modal>
    )
}

export default IFrameSettingsModal;